import { useContext } from 'react';
import { CampaignContext } from './CampaignContext';

/**
 * Custom hook to consume Campaign Context
 * @returns {Object} Campaign context value
 */
export const useCampaign = () => {
  const context = useContext(CampaignContext);

  if (!context) {
    throw new Error('useCampaign must be used within a CampaignProvider');
  }

  return context;
};
